import raymond from '../../assets/brands/raymond.png';
import reidTaylor from '../../assets/brands/reid-taylor.png';
import scabal from '../../assets/brands/scabal.png';

export default function Brands() {
  const brands = [
    { name: "Raymond", logo: raymond },
    { name: "Reid & Taylor", logo: reidTaylor },
    { name: "Scabal", logo: scabal }
  ];

  // Double the brands for seamless scrolling
  const scrollBrands = [...brands, ...brands, ...brands, ...brands];

  return (
    <section className="py-24 bg-white overflow-hidden border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-16">
        <h2 className="text-sm font-semibold tracking-[0.3em] uppercase text-[#d4af37] mb-4">Our Heritage Partners</h2>
        <p className="text-3xl md:text-4xl font-serif text-gray-900 leading-tight">
          Crafting Excellence with Global Icons
        </p>
      </div>

      <div className="relative">
        {/* Gradient Fades for Smooth Transitions */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10"></div>

        <div className="flex animate-marquee whitespace-nowrap gap-12 md:gap-24 items-center py-4">
          {scrollBrands.map((brand, index) => (
            <div 
              key={index} 
              className="flex-shrink-0 flex flex-col items-center gap-6 group"
            >
              <div className="w-48 h-28 md:w-64 md:h-36 overflow-hidden rounded-xl bg-gray-50 flex items-center justify-center p-6 border border-gray-100 hover:border-[#d4af37] transition-all duration-500 shadow-sm hover:shadow-xl hover:-translate-y-2">
                <img 
                  src={brand.logo} 
                  alt={`${brand.name} Logo`} 
                  className="w-full h-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-700" 
                />
              </div>
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-gray-400 group-hover:text-[#d4af37] transition-colors duration-300">
                {brand.name}
              </span>
            </div>
          ))}
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          display: flex;
          width: max-content;
          animation: marquee 40s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}} />
    </section>
  );
}